import React, { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";

function Background(props) {
  const [curBG, setCurBg] = useState(new Date().getHours());
  const [timeRestrict, setTR] = useState("");
  const windowWidth = window.innerWidth;

  useEffect(() => {
    setInterval(() => setCurBg(new Date().getHours()), 1000);
  }, []);

  useEffect(() => {
    if (props.timeRestrict != null) {
      setTR(props.timeRestrict);
    } else {
      setTR("");
    }
  }, [props.timeRestrict]);
  let curTime = "day";

  if (curBG >= 7 && curBG < 19) {
    if (props.type !== "pet-and-owner-creation") {
      curTime = "day";
    } else {
      curTime = "twilight";
    }
  } else if (curBG >= 19 && curBG < 20) {
    curTime = "sunset";
  } else if (curBG >= 20 || curBG < 6) {
    curTime = "night";
  }

  return (
    <>
      {windowWidth > 991 && (
        <>
          <div
            style={{ top: "2%", position: "fixed", right: "0", width: "100%" }}
            className={`video-tag ${props.class}`}
            data-vide-bg="video/tr"
          >
            <div className="videoBG" style={{ marginTop: "-2.5rem" }}>
              <div className="black-background"></div>
              <img 
                className="super-background"
                src={`/images/background-and-sounds/${props.type}/${curTime}_image.jpg`} alt="loader"
              />
              {timeRestrict == "" && (
                <video
                  poster={`/images/background-and-sounds/${props.type}/${curTime}_image.jpg`}
                  autoPlay
                  loop
                  muted
                  className="videoTag"
                >
                  <source
                    src={`/images/background-and-sounds/${props.type}/${curTime}_compressed_video.m4v`}
                    type="video/mp4"
                  />
                </video>
              )}
              {timeRestrict != "" && (
                <video
                  poster={`/images/background-and-sounds/${props.type}/${timeRestrict}_image.jpg`}
                  autoPlay
                  loop
                  muted
                  className="videoTag"
                >
                  <source
                    src={`/images/background-and-sounds/${props.type}/${timeRestrict}_compressed_video.m4v`}
                    type="video/mp4"
                  />
                </video>
              )}
            </div>
          </div>{" "}
          {/*position:absolute;z-index:-1;inset:0;background-size:cover;background-repeat:no-repeat;background-position:50% 50%;background-image:none*/}
          {/*<div className="videoBG" style={{marginTop:"50%", position:"absolute"}}>
                <img src={`/images/background-and-sounds/${props.type}/${curTime}_image.jpg`} style={{width:"100%", transform: "scaleY(-1)"}}/>
            </div>*/}
        </>
      )}
      {isMobile && windowWidth < 540 ? (
        <div
          style={{
            position: "fixed",
            height: "100%",
            width: "100%",
            zIndex: "-2",
          }}
        >
          <img
            style={{ height: "100%", width: "100%", zIndex: "-2" }}
            src={`/images/background-and-sounds/${props.type}/${
              timeRestrict == "" ? curTime : timeRestrict
            }_image_mobile.jpg`}
            alt=""
          />
        </div>
      ) : (
        <div
          style={{ top: "10%", position: "fixed", right: "0", width: "100%" }}
          className={`video-tag ${props.class}`}
          data-vide-bg="video/tr"
        >
          <div className="videoBG" style={{ marginTop: "-2.5rem" }}>
            <video
              poster={`/images/background-and-sounds/${props.type}/${
                timeRestrict == "" ? curTime : timeRestrict
              }_image.jpg`}
              autoPlay
              loop
              muted
              className="videoTag"
            >
              <source
                src={`/images/background-and-sounds/${props.type}/${
                  timeRestrict == "" ? curTime : timeRestrict
                }_compressed_video.m4v`}
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      )}
    </>
  );
}

export default Background;
